module.exports = __webpack_public_path__ + "static/media/sandwich.c5022eb4.png";